<template>
  <button class="big-button" @click="onClick">
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: 'BigButton',
    props: {},
    methods: {
      onClick(event) {
        this.$emit('click', event);
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../config/styles/settings";
  @import "../../config/styles/util";

  .big-button {
    @include reset-button;
    @include shadow-float;
    font-size: 1.5em;
    text-transform: uppercase;
    padding: $gutter ($gutter * 2.5);
    background: $yellow-500;
    color: $black;
    transition: 110ms ease-in-out all;
    animation-name: elevate;
    animation-duration: 2.25s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;

    &:hover {
      background: $yellow-400;
    }

    &:active {
      background: $yellow-500;
    }
  }

  @keyframes elevate {
    from {
      transform: rotate(-3deg);
    }
    to {
      transform: rotate(3deg);
    }
  }
</style>
